
import { computed, defineComponent} from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'FormTab',
  props: {
    index: Number,
  },
  setup() {
    const store = useStore()
    const currentTab = computed(() => store.getters.currentTab)

    return {
      currentTab
    }
  }
})
